import { render } from "./MerchantInquiryListPage.vue?vue&type=template&id=1550c5d4&scoped=true"
import script from "./MerchantInquiryListPage.vue?vue&type=script&lang=js"
export * from "./MerchantInquiryListPage.vue?vue&type=script&lang=js"

import "./MerchantInquiryListPage.vue?vue&type=style&index=0&id=1550c5d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1550c5d4"

export default script